import React from 'react';

function Footer() {
    return (  
    <header>
        <h3 className="Footer"><a href="https://www.makeschool.com/portfolio/cao-mai" target="_blank">&copy;caocmai </a> &nbsp; {new Date().getFullYear()}</h3>
    </header>
    )
}

export default Footer;
